import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'college-profile-page.links-and-profiles.add-profile.header',
    defaultMessage: 'Profile',
  },
  upload_photo: {
    id: 'college-profile-page.links-and-profiles.add-profile.upload-photo',
    defaultMessage: 'Upload Photo',
  },
  edit_photo: {
    id: 'college-profile-page.links-and-profiles.add-profile.edit-photo',
    defaultMessage: 'Edit Photo',
  },
  persons_name: {
    id: 'college-profile-page.links-and-profiles.add-profile.persons_name',
    defaultMessage: 'Name',
  },
  invalid_persons_name: {
    id: 'college-profile-page.links-and-profiles.add-profile.persons_name.invalid',
    defaultMessage: 'Name is required.',
  },
  program_name: {
    id: 'college-profile-page.links-and-profiles.add-profile.program_name',
    defaultMessage: 'Program Name',
  },
  program_name_placeholder: {
    id: 'college-profile-page.links-and-profiles.add-profile.program_name.placeholder',
    defaultMessage: 'Example: Marine Biology',
  },
  invalid_program_name: {
    id: 'college-profile-page.links-and-profiles.add-profile.program_name.invalid',
    defaultMessage: 'Program Name is required.',
  },
  graduation_year: {
    id: 'college-profile-page.links-and-profiles.add-profile.graduation_year',
    defaultMessage: 'Graduation Year',
  },
  invalid_graduation_year: {
    id: 'college-profile-page.links-and-profiles.add-profile.graduation_year.invalid',
    defaultMessage: 'Graduation Year is required.',
  },
  hometown: {
    id: 'college-profile-page.links-and-profiles.add-profile.hometown',
    defaultMessage: 'Hometown',
  },
  hometown_placeholder: {
    id: 'college-profile-page.links-and-profiles.add-profile.hometown.placeholder',
    defaultMessage: 'City, State',
  },
  invalid_hometown: {
    id: 'college-profile-page.links-and-profiles.add-profile.hometown.invalid',
    defaultMessage: 'Hometown is required.',
  },
  major: {
    id: 'college-profile-page.links-and-profiles.add-profile.major',
    defaultMessage: 'Major',
  },
  major_placeholder: {
    id: 'college-profile-page.links-and-profiles.add-profile.major.placeholder',
    defaultMessage: 'Example: Computer Science',
  },
  invalid_major: {
    id: 'college-profile-page.links-and-profiles.add-profile.major.invalid',
    defaultMessage: 'Major is required.',
  },
  quote: {
    id: 'college-profile-page.links-and-profiles.add-profile.quote',
    defaultMessage: 'Quote',
  },
  quote_placeholder: {
    id: 'college-profile-page.links-and-profiles.add-profile.quote.placeholder',
    defaultMessage: 'A favorite quote or note about the college.',
  },
  program_quote_placeholder: {
    id: 'college-profile-page.links-and-profiles.add-profile.quote.program.placeholder',
    defaultMessage: 'A favorite quote or note about the program.',
  },
  invalid_quote: {
    id: 'college-profile-page.links-and-profiles.add-profile.quote.invalid',
    defaultMessage: 'Quote is required.',
  },
  about: {
    id: 'college-profile-page.links-and-profiles.add-profile.about',
    defaultMessage: 'About the {type}',
  },
  about_faculty_member: {
    id: 'college-profile-page.links-and-profiles.add-profile.about_faculty_member',
    defaultMessage: 'About the Faculty Member',
  },
  about_alumnus: {
    id: 'college-profile-page.links-and-profiles.add-profile.about_alumnus',
    defaultMessage: 'About this Alumnus',
  },
  invalid_about: {
    id: 'college-profile-page.links-and-profiles.add-profile.about.invalid',
    defaultMessage: 'About the Student is required.',
  },
  invalid_about_faculty_member: {
    id: 'college-profile-page.links-and-profiles.add-profile.about_faculty_member.invalid',
    defaultMessage: 'About the Faculty Member is required.',
  },
  invalid_about_alumnus: {
    id: 'college-profile-page.links-and-profiles.add-profile.about_alumnus.invalid',
    defaultMessage: 'About this Alumnus is required.',
  },
  about_placeholder: {
    id: 'college-profile-page.links-and-profiles.add-profile.about_placeholder',
    defaultMessage: 'Include biographical information, specialties, accolades, etc.',
  },
  program_description: {
    id: 'college-profile-page.links-and-profiles.add-profile.program_description',
    defaultMessage: 'Program Description',
  },
  invalid_program_description: {
    id: 'college-profile-page.links-and-profiles.add-profile.program_description.invalid',
    defaultMessage: 'Program Description is required.',
  },
  program_description_placeholder: {
    id: 'college-profile-page.links-and-profiles.add-profile.program_description.placeholder',
    defaultMessage: 'Stats about program success rates, job placement, etc.',
  },
  fav_activities: {
    id: 'college-profile-page.links-and-profiles.add-profile.fav_activities',
    defaultMessage: 'Favorite Activities',
  },
  fav_hangout: {
    id: 'college-profile-page.links-and-profiles.add-profile.fav_hangout',
    defaultMessage: 'Favorite Hangout',
  },
  best_place_to_eat: {
    id: 'college-profile-page.links-and-profiles.add-profile.best_place_to_eat',
    defaultMessage: 'Best Place To Eat',
  },
  fav_event: {
    id: 'college-profile-page.links-and-profiles.add-profile.fav_event',
    defaultMessage: 'Favorite Event',
  },
  fav_tradition: {
    id: 'college-profile-page.links-and-profiles.add-profile.fav_tradition',
    defaultMessage: 'Favorite Tradition',
  },
  travel: {
    id: 'college-profile-page.links-and-profiles.add-profile.travel',
    defaultMessage: 'How Most Students Travel',
  },
  editProfilePictureInstructions1: {
    id: 'college-profile-page.links-and-profiles.edit-photo.instructions1',
    defaultMessage: 'Images must be JPG or PNG format with a file size less than 20MB.',
  },
  editProfilePictureInstructions2: {
    id: 'college-profile-page.links-and-profiles.edit-photo.instructions2',
    defaultMessage: 'A square image will fit best in the available space.',
  },
  continueEditingProfile: {
    id: 'college-profile-page.links-and-profiles.edit-profile.continue-editing',
    defaultMessage: 'Continue Editing Profile',
  },
  cropPhotoInstructionsCircle: {
    id: 'college-profile-page.links-and-profiles.crop-photo-instructions-circle',
    defaultMessage: 'Crop and move the photo to the position in the circle that fits best.',
  },
  imageUploading: {
    id: 'edit-profile-picture.drop-zone.imageUploading',
    defaultMessage: 'Uploading image...',
  },
});

export default messages;
